import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import DeleteHighlightConfirm from "./DeleteHighlightConfirm";
import { Trash2 } from "lucide-react";
import { functions } from "../../Security/firebase-config";
import { useAuth } from "../../context/AuthContext";
import { FUNCTION_NAMES } from "../../utils/functionNames";

export default function PublicClipRemoveButton({ clip, onRemoved, onFeedback }) {
  const { userData } = useAuth();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [removing, setRemoving] = useState(false);
  if (!userData?.uid || userData.uid !== clip?.ownerUid) return null;

  async function remove() {
    if (removing) return;
    setRemoving(true);
    try {
      await httpsCallable(functions, FUNCTION_NAMES.deletePublicClip)({ clipId: clip.clipId });
      onRemoved(clip.clipId);
      onFeedback({ tone: "success", message: "Clip removed from the public page." });
    } catch (error) {
      onFeedback({ tone: "error", message: error?.message || "Unable to remove this public clip. Please try again." });
    } finally {
      setRemoving(false);
      setConfirmOpen(false);
    }
  }

  return <><button type="button" className="public-clips-browser__icon-button"
    title="Take clip offline" aria-label={removing ? "Taking clip offline" : "Take clip offline"}
    disabled={removing} onClick={() => setConfirmOpen(true)}><Trash2 size={16} aria-hidden="true" /></button>
    {confirmOpen && <DeleteHighlightConfirm
      message={`Take "${clip.title}" off the public page? Its public link will stop working. Your local clip will be kept.`}
      confirmLabel="Take offline" workingLabel="Taking offline..." workingStatusLabel="Removing public clip..."
      onCancel={() => setConfirmOpen(false)} onConfirm={remove}
    />}
  </>;
}
